export default "__VITE_ASSET__d6wUhBkz__"